module.exports = __webpack_public_path__ + "img/present2.2ccdf263.png";